export default {
  isAuthed: (state) => {
    return state.expiresAt !== undefined && new Date(state.expiresAt).getTime() > Date.now()
  }
}
